'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoAuthLogin = exports.isIpad = exports.isMobileDevice = exports.isMobileorisIpad = exports.getEventList = exports.routerAfterEach = exports.routerBeforeEach = undefined;

var _iview = require('iview');

var _iview2 = _interopRequireDefault(_iview);

var _axios = require('@/plugins/axios');

var _axios2 = _interopRequireDefault(_axios);

var _config = require('@/config');

var _jsBase = require('js-base64');

var _jsMd = require('js-md5');

var _jsMd2 = _interopRequireDefault(_jsMd);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routerBeforeEach = exports.routerBeforeEach = function routerBeforeEach(to, from, resolve) {
  if (isMobileDevice() || isIpad()) {
    if (location.hash.includes('microLesson/microLesson-whitelist') && (location.hash.includes('-OPEN') || location.hash.includes('-open'))) {
      //手机或平板
      isMobileorisIpad();
      return;
    }
  }
  var token = sessionStorage.getItem('authLogin');
  if (!token && to.name == 'oauthLogin' && to.query.oauth) {
    autoAuthLogin(to, from, resolve);
    return;
  }
  getEventList(to, from, resolve);
  if (_store2.default.state.filterLoginPage.includes(to.name)) {
    resolve();
    return;
  } else if (!token && _store2.default.state.filterLoginPage.includes(to.name)) {
    resolve({ path: '/' });
    return;
  } else if (token && token !== 'null' && (to.name === 'login' || to.name === 'toonLogin')) {
    //未登录状态，重定向到首页
    resolve(_config.indexRouter);
    return;
  } else if (!token && _store2.default.state.filterLoginPage.includes(to.name)) {
    resolve();
    return;
  }
  _iview2.default.LoadingBar.start();
  resolve();
};
var routerAfterEach = exports.routerAfterEach = function routerAfterEach(to, from) {
  _iview2.default.LoadingBar.finish();
};
var getEventList = exports.getEventList = function getEventList(to, from, resolve) {
  // axios({
  //   url: `user/open/metricPage`,
  //   method: 'GET'
  // })
};
var isMobileorisIpad = exports.isMobileorisIpad = function isMobileorisIpad(to, from, resolve) {
  // location.href = 'http://192.168.15.56:8000' + '/page/microLesson/microLesson-whitelist/microLesson-whitelist.html?queryCategoryCode=kcps0718-OPEN'
  location.href = location.origin + '/wechat' + '/page/microLesson/microLesson-whitelist/microLesson-whitelist.html?queryCategoryCode=kcps0718-OPEN';
};
var isMobileDevice = exports.isMobileDevice = function isMobileDevice(to, from, resolve) {
  // 使用userAgent判断
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
};
var isIpad = exports.isIpad = function isIpad(to, from, resolve) {
  // 判断新款pad
  return navigator.userAgent.match(/(iPad)/) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};

var autoAuthLogin = exports.autoAuthLogin = function autoAuthLogin(to, from, resolve) {
  var pwd = (0, _jsMd2.default)(to.query.password);
  (0, _axios2.default)({
    url: 'user',
    headers: {
      'Authorization': 'Basic ' + _jsBase.Base64.encode(to.query.loginName + ':' + pwd),
      'client': 'PC'
    },
    data: {
      captcha: to.query.loginName
    },
    method: 'GET'
  }).then(function (_ref) {
    var data = _ref.data;

    if (data.authenticated) {
      getEventList(to, from, resolve);
      resolve(_config.indexRouter);
      return false;
    }
  });
};